import { render, staticRenderFns } from "./latest-order-pulls-grid.vue?vue&type=template&id=a3815cf8&scoped=true"
import script from "./latest-order-pulls-grid.vue?vue&type=script&lang=js"
export * from "./latest-order-pulls-grid.vue?vue&type=script&lang=js"
import style0 from "./latest-order-pulls-grid.vue?vue&type=style&index=0&id=a3815cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3815cf8",
  null
  
)

export default component.exports